import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, finalize } from 'rxjs';

import { Announcement } from '@shared/models';

import { BaseService } from '../base.service';
import { LoadersService } from '../loaders.service';

@Injectable({ providedIn: 'root' })
export class AnnouncementsService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  getAll(loader: string): Observable<Announcement[]> {
    this.loadersService.show(loader);
    return this.http
      .get<Announcement[]>(`${this.baseUrl}/announcements`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getActive(version: string, route: string): Observable<Announcement[]> {
    const params = new HttpParams().set('version', version).set('route', route);
    return this.http.get<Announcement[]>(`${this.baseUrl}/announcements/active`, { params });
  }

  save(announcement: Announcement, loader: string): Observable<Announcement> {
    this.loadersService.show(loader);
    const result = announcement.id
      ? this.http.put<Announcement>(`${this.baseUrl}/announcements`, announcement)
      : this.http.post<Announcement>(`${this.baseUrl}/announcements`, announcement);
    return result.pipe(finalize(() => this.loadersService.hide(loader)));
  }

  delete(id: string, loader: string): Observable<void> {
    this.loadersService.show(loader);
    return this.http
      .delete<void>(`${this.baseUrl}/announcements/${id}`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }
}
